import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import { useCreateAgreement } from '../Agreement.hooks';
import { Agreement, AgreementCreateDto } from '../Agreement.interface';

export interface AgreementCreateDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: (agreement: Agreement) => void;
}

const AgreementCreateDialog: React.FC<AgreementCreateDialogProps> = ({
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const { agreement, isLoading, error, post } = useCreateAgreement();
  useEffect(() => {
    if (!isLoading) {
      if (onCreated && agreement) {
        onCreated(agreement);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [agreement, isLoading, onCreated]);
  return (
    <Dialog open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ name: '' }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required')
        })}
        onSubmit={(agreementDto: AgreementCreateDto) => {
          post(agreementDto);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>New Agreement</DialogTitle>
          <DialogContent>
            <DialogContentText>
              What is the name of the agreement?
            </DialogContentText>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Agreement Name'
              />
            </FormikGrid>
            {error && (
              <Alert severity='error'>
                Error occurred. Please check your internet connection and try
                again.
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default AgreementCreateDialog;
